import { ReactNode } from 'react'

const VerticalySplittedLayout = ({
    top,
    bottom,
    topHeight = 'auto',
}: {
    top: ReactNode
    bottom: ReactNode
    topHeight?: string
}) => {
    return (
        <div className="flex flex-col h-[calc(100svh-120px)]  gap-1 px-5 ">
            <div
                className='overflow-y-auto'
                style={{ height: topHeight }}
            >
                {top}
            </div>
            <div
                className="flex-1 overflow-y-auto"
                style={{ height: `calc(100%-${topHeight})` }}
            >
                {bottom}
            </div>
        </div>
    )
}

export default VerticalySplittedLayout
